// import React from 'react'
import styled from 'styled-components'
import { parseRem } from 'styles'

// Types
import { BorderRadius, SpacingStack } from 'types'
interface StyleProps {
  padding?: number | string
  gap?: SpacingStack
  borderRadius?: BorderRadius
  backgroundColor?: string
  flexDirection?: string
}

export const BoxSection = styled.section<StyleProps>`
  flex: 1;
  display: flex;
  justify-content: space-between;
  flex-direction: ${(props) => props.flexDirection ?? 'column'};
  gap: ${(props) =>
    props.gap !== undefined ? parseRem(props.gap) : parseRem(40)};
  background-color: ${(props) =>
    props.backgroundColor
      ? props.backgroundColor
      : props.theme.colors.background.default};
  padding: ${(props) =>
    props.padding
      ? typeof props.padding === 'string'
        ? props.padding
        : parseRem(props.padding)
      : parseRem(24)};
  border-radius: ${(props) =>
    props.borderRadius
      ? typeof props.borderRadius === 'string'
        ? props.borderRadius
        : parseRem(props.borderRadius)
      : parseRem(16)};
`
